import * as React from 'react';
import * as moment from 'moment';
import { ListDayProps } from '../../components/list/day';
import ListEvent from '../../components/list/event';


const GridDayView: React.StatelessComponent<ListDayProps> = props => {
    return (
        <>
            {
                props.day.events.map(event => <ListEvent key={event.id} event={event} />)
            }
        </>
    );
}

export default GridDayView;